(function () {
  var STYLE_ID = 'cbdmd-aftersell-fbt-style';
  var CSS = [
    '.pdp-widget {',
    '  --pdp-widget-background-color: transparent;',
    '  --pdp-widget-border-width: 0;',
    '  --pdp-widget-padding-top: 0;',
    '  --pdp-widget-padding-right: 0;',
    '  --pdp-widget-padding-bottom: 0;',
    '  --pdp-widget-padding-left: 0;',
    '  --pdp-header-alignment: left;',
    '  --pdp-header-font-size: 16px;',
    '  --pdp-header-text-font-weight: 700;',
    '  --pdp-header-background-color: transparent;',
    '  --pdp-header-border-width: 0;',
    '  --pdp-header-text-color: #000;',
    '  --pdp-product-image-width: 80px;',
    '  --pdp-product-image-height: 80px;',
    '  --pdp-product-image-border-radius: 20px;',
    '  --pdp-product-image-background-color: #fff;',
    '  --pdp-product-image-border-width: 0;',
    '  --pdp-product-card-background-color: transparent;',
    '  --pdp-product-card-border-width: 0;',
    '  --pdp-product-card-padding: 0;',
    '  --pdp-product-card-max-width: none;',
    '  --pdp-product-title-font-size: 14px;',
    '  --pdp-product-title-font-weight: 700;',
    '  --pdp-product-title-text-color: #000;',
    '  --pdp-product-title-alignment: start;',
    '  --pdp-price-text-font-size: 14px;',
    '  --pdp-price-text-font-weight: 700;',
    '  --pdp-price-text-color: #000;',
    '  --pdp-add-to-cart-button-background-color: #63d693;',
    '  --pdp-add-to-cart-button-text-color: #000;',
    '  --pdp-add-to-cart-button-font-size: 16px;',
    '  --pdp-add-to-cart-button-font-weight: 700;',
    '  --pdp-add-to-cart-button-border-radius: 999px;',
    '  --pdp-add-to-cart-button-border-width: 1px;',
    '  --pdp-add-to-cart-button-border-color: #000;',
    '  --pdp-add-to-cart-button-width: auto;',
    '  --pdp-add-to-cart-button-hover-background-color: #63d693;',
    '  --pdp-add-to-cart-button-hover-text-color: #000;',
    '  --pdp-add-to-cart-button-hover-border-color: #000;',
    '  font-family: var(--body-font-family, inherit);',
    '  border: none;',
    '  background: transparent;',
    '  padding: 0;',
    '  border-radius: 0;',
    '}',
    '.pdp-widget .upsell-header {',
    '  text-transform: uppercase;',
    '  margin: 0 0 10px;',
    '  padding: 0;',
    '  line-height: 1.2;',
    '  border: none;',
    '  background: transparent;',
    '  text-align: left;',
    '}',
    '.pdp-widget .bundle-upsell-wrapper {',
    '  border: 1px solid #58D088;',
    '  border-radius: 20px;',
    '  background: #eef6ef;',
    '  padding: 15px 19px 12px;',
    '  gap: 16px;',
    '}',
    '.pdp-widget .carousel-wrapper {',
    '  width: 100%;',
    '}',
    '.pdp-widget .carousel-button {',
    '  display: none;',
    '}',
    '.pdp-widget .product-card-container.horizontal {',
    '  gap: 0;',
    '  align-items: center;',
    '}',
    '.pdp-widget .product-card.horizontal {',
    '  gap: 0;',
    '  min-width: 0;',
    '  width: auto;',
    '}',
    '.pdp-widget .product-image {',
    '  object-fit: contain;',
    '}',
    '.pdp-widget .plus-icon-wrapper:not(.vertical) {',
    '  width: 19px;',
    '  height: 19px;',
    '  min-width: 19px;',
    '  margin: 0 8px;',
    '  background: #000;',
    '  border-radius: 50%;',
    '  display: flex;',
    '  align-items: center;',
    '  justify-content: center;',
    '}',
    '.pdp-widget .plus-icon-wrapper.vertical {',
    '  width: 19px;',
    '  height: 19px;',
    '  min-width: 19px;',
    '  max-width: 19px;',
    '  background: #000;',
    '  border-radius: 50%;',
    '  display: flex;',
    '  align-items: center;',
    '  justify-content: center;',
    '}',
    '.pdp-widget .plus-icon {',
    '  color: #fff;',
    '  font-size: 14px;',
    '  line-height: 1;',
    '  font-weight: 400;',
    '}',
    '.pdp-widget .product-info {',
    '  padding-bottom: 0;',
    '  gap: 2px;',
    '}',
    '.pdp-widget .product-title a {',
    '  text-decoration: underline;',
    '  color: #000;',
    '  line-height: 1.3;',
    '}',
    '.pdp-widget .product-title a:hover {',
    '  text-decoration: underline;',
    '}',
    '.pdp-widget .price-info {',
    '  font-weight: 700;',
    '}',
    '.pdp-widget .product-card-actions {',
    '  display: none;',
    '}',
    '.pdp-widget .add-button {',
    '  text-transform: capitalize;',
    '  white-space: nowrap;',
    '  padding: 12px 24px;',
    '  height: auto;',
    '  min-height: 50px;',
    '}',
    '.pdp-widget .cbdmd-fbt__total-label {',
    '  display: flex;',
    '  flex-direction: column;',
    '  align-items: flex-end;',
    '  text-align: right;',
    '  font-size: 10px;',
    '  line-height: 16px;',
    '  text-transform: uppercase;',
    '  color: #000;',
    '}',
    '.pdp-widget .cbdmd-fbt__total-value {',
    '  font-size: 16px;',
    '  font-weight: 700;',
    '  line-height: 21px;',
    '  text-transform: none;',
    '}',
    '.pdp-widget.cbdmd-layout-vertical .bundle-upsell-wrapper {',
    '  display: flex;',
    '  flex-direction: column;',
    '  align-items: stretch;',
    '  gap: 10px;',
    '  padding: 13px 17px 10px;',
    '}',
    '.pdp-widget.cbdmd-layout-vertical .product-card-container.bundle.vertical {',
    '  display: grid;',
    '  grid-template-columns: var(--pdp-product-image-width, 80px) minmax(0, 1fr);',
    '  grid-template-rows: auto 19px auto;',
    '  column-gap: 12px;',
    '  row-gap: 0;',
    '  width: 100%;',
    '  align-items: start;',
    '}',
    '.pdp-widget.cbdmd-layout-vertical .product-card.vertical {',
    '  display: contents;',
    '}',
    '.pdp-widget.cbdmd-layout-vertical .product-card-container.bundle.vertical > .product-card.vertical:first-of-type .product-image-wrapper.vertical {',
    '  grid-column: 1;',
    '  grid-row: 1;',
    '}',
    '.pdp-widget.cbdmd-layout-vertical .product-card-container.bundle.vertical > .product-card.vertical:first-of-type .product-info-wrapper.vertical {',
    '  grid-column: 2;',
    '  grid-row: 1;',
    '  align-self: start;',
    '}',
    '.pdp-widget.cbdmd-layout-vertical .product-card-container.bundle.vertical > .plus-icon-wrapper.vertical {',
    '  grid-column: 1;',
    '  grid-row: 2;',
    '  justify-self: center;',
    '  align-self: center;',
    '  margin: -8px 0;',
    '  z-index: 2;',
    '}',
    '.pdp-widget.cbdmd-layout-vertical .product-card-container.bundle.vertical > .product-card.vertical:last-of-type .product-image-wrapper.vertical {',
    '  grid-column: 1;',
    '  grid-row: 3;',
    '}',
    '.pdp-widget.cbdmd-layout-vertical .product-card-container.bundle.vertical > .product-card.vertical:last-of-type .product-info-wrapper.vertical {',
    '  grid-column: 2;',
    '  grid-row: 3;',
    '  align-self: start;',
    '}',
    '.pdp-widget.cbdmd-layout-vertical .product-image-wrapper.vertical {',
    '  flex: 0 0 auto;',
    '  max-width: none;',
    '}',
    '.pdp-widget.cbdmd-layout-vertical .product-info-wrapper.vertical {',
    '  flex: 1;',
    '  min-width: 0;',
    '}',
    '.pdp-widget.cbdmd-layout-vertical .vertical-layout-divider.product {',
    '  width: 100%;',
    '}',
    '.pdp-widget.cbdmd-layout-vertical .product-info {',
    '  gap: 1px;',
    '}',
    '.pdp-widget.cbdmd-layout-vertical .cbdmd-fbt__items {',
    '  display: none;',
    '}',
    '.pdp-widget.cbdmd-layout-vertical .add-button {',
    '  width: auto;',
    '  align-self: flex-end;',
    '  margin-left: auto;',
    '  min-height: 44px;',
    '  padding: 10px 20px;',
    '}',
    '@media (min-width: 769px) {',
    '  .pdp-widget.cbdmd-layout-horizontal .bundle-upsell-wrapper {',
    '    display: grid;',
    '    grid-template-columns: auto minmax(0, 1fr) auto;',
    '    grid-template-rows: auto auto;',
    '    align-items: center;',
    '    column-gap: 16px;',
    '    row-gap: 9px;',
    '    padding: 13px 17px;',
    '  }',
    '  .pdp-widget.cbdmd-layout-horizontal .carousel-wrapper {',
    '    grid-column: 1;',
    '    grid-row: 1 / span 2;',
    '    width: auto;',
    '    min-width: 0;',
    '  }',
    '  .pdp-widget.cbdmd-layout-horizontal .product-card-container.horizontal {',
    '    flex-wrap: nowrap;',
    '  }',
    '  .pdp-widget.cbdmd-layout-horizontal .product-card.horizontal {',
    '    flex-direction: column;',
    '    align-items: center;',
    '    max-width: 96px;',
    '  }',
    '  .pdp-widget.cbdmd-layout-horizontal .product-info-wrapper {',
    '    display: none;',
    '  }',
    '  .pdp-widget.cbdmd-layout-horizontal .cbdmd-fbt__items {',
    '    grid-column: 2;',
    '    grid-row: 1 / span 2;',
    '    display: flex;',
    '    flex-direction: column;',
    '    gap: 8px;',
    '    text-align: left;',
    '    align-self: center;',
    '  }',
    '  .pdp-widget.cbdmd-layout-horizontal .cbdmd-fbt__item {',
    '    display: flex;',
    '    flex-direction: column;',
    '    gap: 2px;',
    '  }',
    '  .pdp-widget.cbdmd-layout-horizontal .cbdmd-fbt__item-title {',
    '    font-size: 14px;',
    '    font-weight: 700;',
    '    line-height: 1.3;',
    '    color: #000;',
    '    text-decoration: underline;',
    '  }',
    '  .pdp-widget.cbdmd-layout-horizontal .cbdmd-fbt__item-price {',
    '    font-size: 14px;',
    '    font-weight: 700;',
    '    color: #000;',
    '  }',
    '  .pdp-widget.cbdmd-layout-horizontal .cbdmd-fbt__total-label {',
    '    grid-column: 3;',
    '    grid-row: 1;',
    '    justify-self: end;',
    '  }',
    '  .pdp-widget.cbdmd-layout-horizontal .add-button {',
    '    grid-column: 3;',
    '    grid-row: 2;',
    '    justify-self: end;',
    '  }',
    '  .pdp-widget.cbdmd-layout-vertical .add-button {',
    '    margin-top: -8%;',
    '  }',
    '}',
    '@media (max-width: 768px) {',
    '  .pdp-widget.cbdmd-layout-horizontal .bundle-upsell-wrapper {',
    '    flex-direction: column;',
    '  }',
    '  .pdp-widget.cbdmd-layout-horizontal .product-card.horizontal {',
    '    max-width: none;',
    '    width: 100%;',
    '    flex-direction: row;',
    '    align-items: flex-start;',
    '    gap: 12px;',
    '  }',
    '  .pdp-widget.cbdmd-layout-horizontal .product-info-wrapper {',
    '    display: flex;',
    '    flex: 1;',
    '  }',
    '  .pdp-widget.cbdmd-layout-horizontal .product-card-actions {',
    '    display: flex;',
    '  }',
    '  .pdp-widget.cbdmd-layout-horizontal .cbdmd-fbt__items {',
    '    display: none;',
    '  }',
    '  .pdp-widget.cbdmd-layout-horizontal .cbdmd-fbt__total-label {',
    '    align-items: flex-start;',
    '    text-align: left;',
    '  }',
    '  .pdp-widget.cbdmd-layout-horizontal .add-button {',
    '    width: 100%;',
    '  }',
    '}'
  ].join('\n');

  function injectStyles(shadowRoot) {
    if (!shadowRoot || shadowRoot.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    shadowRoot.appendChild(style);
  }

  function isVerticalLayout(shadowRoot) {
    return !!shadowRoot.querySelector('.product-card-container.vertical, .product-card.vertical');
  }

  function resetWidgetChrome(shadowRoot) {
    var widget = shadowRoot.querySelector('.pdp-widget');
    if (!widget) return;

    widget.style.setProperty('--pdp-widget-border-width', '0');
    widget.style.setProperty('--pdp-widget-background-color', 'transparent');
    widget.style.setProperty('--pdp-widget-padding-top', '0');
    widget.style.setProperty('--pdp-widget-padding-right', '0');
    widget.style.setProperty('--pdp-widget-padding-bottom', '0');
    widget.style.setProperty('--pdp-widget-padding-left', '0');
    widget.style.setProperty('--pdp-header-border-width', '0');
    widget.style.setProperty('--pdp-header-background-color', 'transparent');
    widget.style.setProperty('--pdp-header-alignment', 'left');
    widget.style.setProperty('--pdp-header-font-size', '16px');
    widget.style.setProperty('--pdp-product-card-border-width', '0');
    widget.style.setProperty('--pdp-product-image-border-width', '0');
    widget.style.setProperty('--pdp-product-image-width', '80px');
    widget.style.setProperty('--pdp-product-image-height', '80px');
    widget.style.setProperty('--pdp-product-image-border-radius', '20px');
    widget.style.setProperty('--pdp-product-image-background-color', '#fff');
    widget.style.setProperty('--pdp-add-to-cart-button-border-radius', '999px');
    widget.style.setProperty('--pdp-add-to-cart-button-font-weight', '700');

    var header = widget.querySelector('.upsell-header');
    if (header) {
      header.style.border = 'none';
      header.style.paddingBottom = '0';
    }
  }

  function getProductCards(wrapper) {
    return wrapper.querySelectorAll('.product-card.vertical, .product-card.horizontal');
  }

  function parseBundleTotal(buttonText) {
    return buttonText.match(/[•·]\s*(\$[\d,.]+)/);
  }

  function setupHorizontalItems(wrapper, cards) {
    var signature = '';
    cards.forEach(function (card) {
      var titleLink = card.querySelector('.product-title a');
      var priceEl = card.querySelector('.price-info');
      if (titleLink && priceEl) {
        signature += titleLink.textContent.trim() + '|' + priceEl.textContent.trim() + ';';
      }
    });

    var itemsCol = wrapper.querySelector('.cbdmd-fbt__items');
    if (itemsCol && itemsCol.dataset.cbdmdSignature === signature) return;

    if (!itemsCol) {
      itemsCol = document.createElement('div');
      itemsCol.className = 'cbdmd-fbt__items';
      var carouselWrapper = wrapper.querySelector('.carousel-wrapper');
      var insertBefore = carouselWrapper ? carouselWrapper.nextSibling : wrapper.querySelector('.add-button');
      wrapper.insertBefore(itemsCol, insertBefore);
    }

    itemsCol.dataset.cbdmdSignature = signature;
    itemsCol.innerHTML = '';
    cards.forEach(function (card) {
      var titleLink = card.querySelector('.product-title a');
      var priceEl = card.querySelector('.price-info');
      if (!titleLink || !priceEl) return;

      var item = document.createElement('div');
      item.className = 'cbdmd-fbt__item';

      var title = document.createElement('a');
      title.className = 'cbdmd-fbt__item-title';
      title.href = titleLink.href;
      title.textContent = titleLink.textContent.trim();
      if (titleLink.target) title.target = titleLink.target;

      var price = document.createElement('div');
      price.className = 'cbdmd-fbt__item-price';
      price.textContent = priceEl.textContent.trim();

      item.appendChild(title);
      item.appendChild(price);
      itemsCol.appendChild(item);
    });
  }

  function getButtonOriginalText(addButton) {
    if (!addButton.dataset.cbdmdOriginalText) {
      addButton.dataset.cbdmdOriginalText = addButton.textContent.trim();
    }
    return addButton.dataset.cbdmdOriginalText;
  }

  function setupBundleButton(wrapper, vertical) {
    var addButton = wrapper.querySelector('.add-button');
    if (!addButton) return;

    var originalText = getButtonOriginalText(addButton);
    var totalMatch = parseBundleTotal(originalText);
    var actions = wrapper.querySelector('.cbdmd-fbt__actions');
    var totalLabel = wrapper.querySelector('.cbdmd-fbt__total-label');

    if (vertical) {
      if (actions) {
        while (actions.firstChild) {
          wrapper.appendChild(actions.firstChild);
        }
        actions.remove();
      }
      if (totalLabel) totalLabel.remove();
      if (addButton.textContent.trim() !== originalText) {
        addButton.textContent = originalText;
      }
      return;
    }

    if (actions) {
      if (addButton.parentNode === actions) {
        wrapper.appendChild(addButton);
      }
      actions.remove();
      totalLabel = wrapper.querySelector('.cbdmd-fbt__total-label');
    }

    if (totalMatch) {
      if (!totalLabel) {
        totalLabel = document.createElement('div');
        totalLabel.className = 'cbdmd-fbt__total-label';
        totalLabel.innerHTML = '<span>TOTAL PRICE:</span><span class="cbdmd-fbt__total-value"></span>';
        wrapper.insertBefore(totalLabel, addButton);
      }
      var totalValue = totalLabel.querySelector('.cbdmd-fbt__total-value');
      if (totalValue) totalValue.textContent = totalMatch[1];
      if (addButton.textContent.trim() !== 'Add To Cart') {
        addButton.textContent = 'Add To Cart';
      }
    } else if (totalLabel) {
      totalLabel.remove();
    }
  }

  function enhanceLayout(shadowRoot) {
    var wrapper = shadowRoot.querySelector('.bundle-upsell-wrapper');
    if (!wrapper) return;

    var widget = shadowRoot.querySelector('.pdp-widget');
    var vertical = isVerticalLayout(shadowRoot);
    var cards = getProductCards(wrapper);
    if (!cards.length) return;

    if (widget) {
      widget.classList.toggle('cbdmd-layout-vertical', vertical);
      widget.classList.toggle('cbdmd-layout-horizontal', !vertical);
    }

    if (vertical) {
      var itemsCol = wrapper.querySelector('.cbdmd-fbt__items');
      if (itemsCol) itemsCol.remove();
    } else {
      setupHorizontalItems(wrapper, cards);
    }

    setupBundleButton(wrapper, vertical);
  }

  function enhance(shadowRoot) {
    injectStyles(shadowRoot);
    resetWidgetChrome(shadowRoot);
    enhanceLayout(shadowRoot);
  }

  function watchHost(host) {
    if (!host || host.dataset.cbdmdWatching === 'true') return;
    host.dataset.cbdmdWatching = 'true';

    var enhancing = false;
    var scheduled = false;
    var shadowObserver = null;

    function tryEnhance() {
      if (!host.shadowRoot || enhancing) return;
      enhancing = true;
      try {
        enhance(host.shadowRoot);
      } finally {
        enhancing = false;
      }
    }

    function scheduleEnhance() {
      if (scheduled || enhancing) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        tryEnhance();
      });
    }

    function observeShadow() {
      if (!host.shadowRoot || shadowObserver) return;
      shadowObserver = new MutationObserver(scheduleEnhance);
      shadowObserver.observe(host.shadowRoot, { childList: true, subtree: true });
    }

    tryEnhance();
    observeShadow();

    var hostObserver = new MutationObserver(function () {
      scheduleEnhance();
      observeShadow();
    });
    hostObserver.observe(host, { childList: true });

    var shadowPoll = setInterval(function () {
      if (!host.shadowRoot) return;
      clearInterval(shadowPoll);
      scheduleEnhance();
      observeShadow();
    }, 200);

    setTimeout(function () {
      clearInterval(shadowPoll);
    }, 20000);
  }

  function init() {
    var host = document.getElementById('aftersell-pdp-upsell');
    if (host) {
      watchHost(host);
      return;
    }

    var block = document.querySelector('[id*="aftersell_pdp_upsells"]');
    if (block) {
      var nestedHost = block.querySelector('#aftersell-pdp-upsell');
      if (nestedHost) watchHost(nestedHost);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
